"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.Container = exports.InnerActiveIconStyled = exports.CheckStyled = exports.ActiveIconStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("@material-ui/icons");
const temaPadrao_1 = __importDefault(require("../../../components/CeMuiThemeProvider/temaPadrao"));
exports.ActiveIconStyled = styled_components_1.default.div `
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${({ theme = temaPadrao_1.default }) => { var _a; return (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.secondary.main; }};
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.CheckStyled = styled_components_1.default(icons_1.Check) `
  color: ${({ theme = temaPadrao_1.default }) => { var _a; return (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.common.white; }};
  z-index: 1;
  font-size: 15px;
`;
exports.InnerActiveIconStyled = styled_components_1.default.div `
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme }) => { var _a; return (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.common.white; }};
`;
exports.Container = styled_components_1.default.div `
  color: #d8d8d8;
  display: flex;
  height: 22px;
  align-items: center;
  ${({ active, completed }) => (active || completed) && `color: #f57922`}
`;
exports.Icon = styled_components_1.default.div `
  color: white;
`;
//# sourceMappingURL=styles.js.map